<template>
  <modal-layout>
    <div class="layer_section-container">
      <div class="layer-content">
        <div class="pop-orderCancel-area">
          <p
            class="tit tit_new"
            v-html="htmlMessage"
          />
        </div>
      </div>
      <div class="align-box size-auto">
        <button
          type="button"
          class="btn-modal_close v2"
          @click="onConfirm"
        >
          확인
        </button>
      </div>
    </div>
  </modal-layout>
</template>
<script>
import ModalLayout from '@/components/global/ModalLayout.vue';
import { log } from '@/utils/common';
import modalMixin from './modal-mixin';

function transformNewline(str) {
  return str.replace(/\n/g, '<br/>');
}

export default {
  name: 'ModalAlert',
  components: {
    ModalLayout,

  },
  mixins: [modalMixin],
  props: {
    text: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      msg: "결제가 정상적으로 진행되지 못하였습니다. 새로 고침 후 다시 진행 부탁드립니다.",
    };
  },
  computed: {
    message() {
      if (this.text) {
        return this.text;
      }
      return this.msg;
    },
    htmlMessage() {
      let result = transformNewline(this.message);
      return result;
    },
  },
  watch: {

  },
  created() {
  },
  mounted() {
    this.confirmPromise = null;
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  methods: {
    // set message before mixin open()
    openWithMessage(msg) {
      this.confirmPromise = new Promise((resolve) => {
        this.resolve = resolve;
      });
      this.msg = msg;
      this.open();

      return this.confirmPromise;
    },
    openUrlOnConfirm(url, msg) {
      this.urlToOpen = url;
      return this.openWithMessage(msg);
    },
    onConfirm() {
      if (this.confirmPromise) {
        this.resolve();
      }

      if (this.urlToOpen) {
        window.open(this.urlToOpen, '_blank');

        window.location.href = '/';
        this.urlToOpen = null; // 사용 후 초기화
      }

      this.$emit('confirm');
      this.close();
    },
    onBeforeDispose() {
      log('ModalConfirm::onBeforeDispose', 'before-dispose');
    },
  },
};
</script>
<style scoped>
.type-wide-a .layer_section-container {
  min-width: 360px;
  min-height: 120px;
}

.layer_section.type-wide-a .layer_section-container .layer-content {
  min-height: 120px;
  width: 100%;
  /* height: 100%; */
  display: flex;
  justify-content: center;
  align-items: center;
}

.btn_group div {
  margin-left: 0;
}

@media( max-width: 768px) {
  .btn_group div .layer_section-container {
    display: block;
  }
}
</style>
